const sessionErrors = {
	STUDIO_OCCUPIED: "studio_occupied",
	READER_OCCUPIED: "reader_occupied",
	RECORDER_OCCUPIED: "recorder_occupied",
	PRODUCTION_OCCUPIED: "production_occupied",
};

export default sessionErrors;
